import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faBirthdayCake, faCalendarAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './RoboticsServices.css';

const SERVICES = [
  {
    icon: faSchool,
    title: 'Robotics for your school or center',
    text: 'We bring our robotics curriculum and equipment to your school, center or institution.',
    points: ['Full curriculum', 'Certified instructors', 'All equipment provided', 'Progress tracking'],
    message: "Hi! I'd like to know more about robotics programs for our school or center.",
    cta: 'Ask about schools',
  },
  {
    icon: faBirthdayCake,
    title: 'Robotics birthday parties',
    text: 'An interactive robotics party your child and their friends will remember.',
    points: ['2-hour interactive session', 'Robot building challenges', 'Custom themes', 'Certificate for every child'],
    message: "Hi! I'd like to book a robotics birthday party.",
    cta: 'Plan a party',
  },
  {
    icon: faCalendarAlt,
    title: 'Workshops & special events',
    text: 'Robotics workshops for STEM days, community events and corporate team building.',
    points: ['Team-building activities', 'Custom workshop design', 'All ages and levels', 'Competitions & prizes'],
    message: "Hi! I'd like to organize a robotics workshop or event.",
    cta: 'Organize a workshop',
  },
];

const whatsappUrl = (text) =>
  `https://api.whatsapp.com/send/?phone=${process.env.REACT_APP_MOBILE_NUMBER1}&text=${encodeURIComponent(
    text
  )}&type=phone_number&app_absent=0`;

const RoboticsServices = () => {
  return (
    <section className="rmsv" aria-labelledby="rmsv-title">
      <div className="rmsv-inner">
        <header className="rmsv-header">
          <span className="rmsv-eyebrow">Book us</span>
          <h2 id="rmsv-title" className="rmsv-title">
            Bring robotics to <span>your space</span>
          </h2>
          <p className="rmsv-sub">Hands-on robotics for schools, parties and events, with all the equipment included.</p>
        </header>

        <div className="rmsv-grid">
          {SERVICES.map((s) => (
            <article key={s.title} className="rmsv-card">
              <span className="rmsv-icon">
                <FontAwesomeIcon icon={s.icon} />
              </span>
              <h3 className="rmsv-card-title">{s.title}</h3>
              <p className="rmsv-card-text">{s.text}</p>
              <ul className="rmsv-points">
                {s.points.map((p) => (
                  <li key={p}>
                    <FontAwesomeIcon icon={faCheck} />
                    {p}
                  </li>
                ))}
              </ul>
              <a href={whatsappUrl(s.message)} target="_blank" rel="noopener noreferrer" className="rmsv-btn">
                <FontAwesomeIcon icon={faWhatsapp} />
                {s.cta}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoboticsServices;